"use strict";

exports.__esModule = true;
var _CommentWordCountElement = require("./CommentWordCountElement");
Object.keys(_CommentWordCountElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentWordCountElement[key]) return;
  exports[key] = _CommentWordCountElement[key];
});
var _CommentWordCountFields = require("./CommentWordCountFields");
Object.keys(_CommentWordCountFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentWordCountFields[key]) return;
  exports[key] = _CommentWordCountFields[key];
});
var _CommentWordCountThumbnail = require("./CommentWordCountThumbnail");
Object.keys(_CommentWordCountThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CommentWordCountThumbnail[key]) return;
  exports[key] = _CommentWordCountThumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});